import styled from "styled-components/macro";
import { editorTypographyStyles } from "../EditorContainer/editorContentStyles";

/**
 * Scope element for the Document History snapshot preview. Carries the same
 * inline font styles, `indented` class and --sw-paragraph-spacing custom
 * property as #editor, so the shared typography rules render the snapshot
 * exactly like the live editor (paragraph spacing, heading sizes, bullets).
 */
export const HistoryPreviewContent = styled.div`
  ${editorTypographyStyles("&")}
`;
